export default {
  setupBrand: "تصنيف المتجر",
  brandSpecialized: "فيم يتخصص متجرك؟",
};
